/* eslint consistent-return: "warn" */
import * as types from '../types';

import scoring from '../modules/scoring';

const initialTextState = {
  activeText: 0,
  texts: [
    {
      source: '',
      utteranceLength: 0,
      results: [
        {
          result: {
            confidence: 0,
            result: '',
          },
          score: '',
          scoreByWord: [],
        },
      ],
      audioBuffer: null,
    },
  ],
};

function text(state = { ...initialTextState }, action) {
  switch (action.type) {
  case types.LAUNCH_TEXT:
    return { ...state, activeText: 0, texts: action.texts };
  case types.SELECT_TEXT:
    return { ...state, activeText: action.index };

  case types.CLEAR_TEXT:
    return {
      activeText: 0,
      texts: [
        {
          source: '',
          utteranceLength: 0,
          results: [
            {
              result: {
                confidence: 0,
                result: '',
              },
              score: '',
              scoreByWord: [],
            },
          ],
          audioBuffer: null,
        },
      ],
    };
  case types.UPDATE_SOURCE:
    {
      if (action.source.length > 200) {
        return state;
      }

      const newState = { ...state };
      newState.texts[state.activeText] = {
        source: action.source,
        translations: {},
        results: [],
        audioBuffer: null,
      };
      return newState;
    }
    break;
  case types.UPDATE_TRANSLATION:
    {
      console.log('update in reducer');
      const newState = { ...state };
      const translations = {
        ...newState.texts[state.activeText].translations,
      };
      console.log(translations);
      Object.assign(translations, action.translation);
      newState.texts[state.activeText].translations = translations;
      console.log(newState);
      return newState;
    }
    break;
  case types.NEXT_SENTENCE:
    if (state.texts.length > state.activeText) {
      return { ...state, activeText: state.activeText + 1 };
    }
    break;

  case types.PREV_SENTENCE:
    if (state.activeText > 0) {
      return { ...state, activeText: state.activeText - 1 };
    }
    break;

  case types.SPLICE_SENTENCE: {
    const texts = [...state.texts];
    let activeText = state.activeText;

    if (texts.length > 1) {
      texts.splice(state.activeText, 1);
    } else {
      texts[state.activeText] = {
        source: '',
        results: [],
        audioBuffer: null,
      };
    }
    activeText = activeText > 0 ? activeText - 1 : 0;

    return { ...state, texts, activeText };
  }
  case types.SET_UTTERANCE_LENGTH: {
    const newTexts = [...state.texts];
    newTexts[state.activeText].utteranceLength = action.utteranceLength;
    return { ...state, texts: newTexts };
  }
  case types.SET_RECORDING: {
    const recTexts = [...state.texts];
    recTexts[state.activeText].audioBuffer = action.buffer;
    recTexts[state.activeText].float32ArrayBuffers =
        action.float32ArrayBuffers;
    return { ...state, texts: recTexts };
  }
  case types.ADD_RESULTS: {
    const score = scoring.getTotalScore(
        state.texts[state.activeText].source,
        action.results.result,
        action.results.confidence,
      );

    const scoreByWord = scoring.getScoreByWord(
        state.texts[state.activeText].source,
        action.results.result,
        score,
        action.results.confidence,
      );

    const resultPackage = {
      result: action.results,
      score,
      scoreByWord,
    };

    const resultTexts = [...state.texts];
    resultTexts[state.activeText].results.push(resultPackage);

    return { ...state, texts: resultTexts };
  }
  default:
    return state;
  }
}

export default text;



// WEBPACK FOOTER //
// ./src/reducers/text.js